import { Injectable, Injector } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Data, CanActivateFn } from "@angular/router";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { AuthService } from "../../services/auth.service";
import { GuardList } from "./guard-list.enum";
import { BaseGuardService } from "./base-guard.service";
import { CanDeactivateGuardService } from "./can-deactivate-guard.service";
import { InstantiateFlowGuardService } from "./instantiate-flow-guard.service";
import { InternalGuardService } from "./internal-guard.service";
import { OrganizationGuardService } from "./organization-guard.service";
import { SystemPermissionGuardService } from "./system-permission-guard.service";
import { ViewDashGuardService } from "./view-dash-guard.service";
import { HomeGuard } from "../../core/components/guards/home.guard";

@Injectable()
export class MasterGuardService  {

    constructor(public svc: AuthService, public router: Router) { }

    private _route: ActivatedRouteSnapshot;
    private _state: RouterStateSnapshot;

    private _unauthorizedRedirect: Observable<UrlTree>;

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        let obs$: Observable<boolean | UrlTree>;
        this._route = route;
        this._state = state;
        this._unauthorizedRedirect = of(this.router.createUrlTree(['/home/unauthorized', { ref: this._state.url }], /* Removed unsupported properties by Angular migration: skipLocationChange. */ {}));
        if (route.data == null || route.data.guards == null || route.data.guards.length === 0) {
            obs$ = of(true);
        } else {
            obs$ = this.buildGuardObservable(route.data.guards);
        }
        return obs$;
    } 

    private buildGuardObservable(guards: GuardList[]): Observable<boolean | UrlTree> {
        let obs$: Observable<boolean | UrlTree>;
        for (let i = 0; i < guards.length; i++) {
            let instance: {
    canActivate: CanActivateFn;
} = this.getGuardInstance(guards[i]);
            let activate$: Observable<boolean | UrlTree> = <Observable<boolean | UrlTree>>instance.canActivate(this._route, this._state);
            obs$ = (obs$ == null)
                ? activate$
                : obs$.pipe(
                    mergeMap((data: boolean | UrlTree) => {
                        if (data instanceof UrlTree)
                            return of(data)
                        else if (data === false) {
                            return this._unauthorizedRedirect;
                        }
                        return activate$;
                    }));
        }
        return obs$;
    }

    private getGuardInstance(guard: GuardList): {
    canActivate: CanActivateFn;
} {
        let instance: {
    canActivate: CanActivateFn;
};
        switch (guard) {
            case GuardList.BaseGuardService:
                instance = new BaseGuardService(this.svc, this.router);
                break;
            case GuardList.InternalGuardService:
                instance = new InternalGuardService(this.svc, this.router);
                break;
            case GuardList.SystemPermissionGuardService:
                instance = new SystemPermissionGuardService(this.svc, this.router);
                break;
            case GuardList.ViewDashGuardService:
                instance = new ViewDashGuardService(this.svc, this.router);
                break;
            //other guards will need to be added as needed; some of them have different signatures and haven't figured how to handle that just yet
        }
        return instance;
    }
}
